import Rollbar from 'rollbar';

export const rollbar =
  process.env.NODE_ENV === 'production'
    ? new Rollbar({
        accessToken: process.env.ROLLBAR_CLIENT_ACCESS_TOKEN,
        captureUncaught: true,
        captureUnhandledRejections: false
      })
    : { error: err => console.log(err) };
